import React, { useState, useEffect, useMemo } from "react";
import FranchDetailPage from "./components/detailpage/deailPage";
import FranchTable from "./components/franchTable/franchTable";
import { baseUrl } from "../../../../network/constants/constants";
import { getConfig } from "../../../../network/auth";
import axios from "../../../../network/api";
import { Container } from "react-bootstrap";
import { Spinner } from "react-bootstrap";
import FranchForm from "./components/franchForm/franchForm";
import "./franchMainScreen.css";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import * as XLSX from "xlsx";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";

const FranchMainScreen = () => {
  const [franchiseData, setFranchiseData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [isEdit, setIsEdit] = useState(false);

  const [selectedFranchise, setSelectedFranchise] = useState(null);
  const [selectedEditFranchise, setSelectedEditFranchise] = useState(null);

  const [userList, setUserList] = useState([]);

  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });
  const [forFilterFranchisee, setForFilterFranchisee] = useState([]);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const showSnackbar = (message, severity = "success") => {
    setSnackbar({ open: true, message, severity });
  };
  const [showSuspendPopup, setShowSuspendPopup] = useState(false);
  const [franchiseeToSuspendId, setFranchiseeToSuspendId] = useState(null);

  const handleReset = () => {
    setStartDate("");
    setEndDate("");
    fetchFranchise();
    setForFilterFranchisee(franchiseData);
    showSnackbar("Filters reset successfully.", "info");
  };
  // const finalFilterData = forFilterFranchisee.length > 0 ? franchiseData : forFilterFranchisee;

  const exportToExcel = () => {
    const worksheet = XLSX.utils.json_to_sheet(
      forFilterFranchisee.length > 0 ? forFilterFranchisee : franchiseData
    );
    const workbook = XLSX.utils.book_new();

    XLSX.utils.book_append_sheet(workbook, worksheet, "franchiseeDetails");
    XLSX.writeFile(workbook, "franchiseeDetails.xlsx");
  };

  const handleFilterFranchisee = () => {
    if (!franchiseData.length) {
      showSnackbar("No business details to filter.", "warning");
      return;
    }

    if (!startDate || !endDate) {
      showSnackbar("Please select both start and end dates.", "error");
      return;
    }

    fetchFranchise(startDate, endDate);
    showSnackbar("Filters applied successfully.", "success");
  };

  const handleSelectFranchise = (franchise) => {
    setSelectedFranchise(franchise);
  };

  // const handleSelectFranchise = (franchise) => {
  //   setSelectedFranchise(franchise);
  //   window.history.pushState({ franchise }, "", `?franchise=${franchise.id}`);
  // };

  // useEffect(() => {
  //   const handlePopState = (event) => {
  //     if (event.state?.franchise) {
  //       setSelectedFranchise(event.state.franchise);
  //     } else {
  //       setSelectedFranchise(null);
  //     }
  //   };

  //   window.addEventListener("popstate", handlePopState);
  //   return () => window.removeEventListener("popstate", handlePopState);
  // }, []);

  const handleGoBack = () => {
    setSelectedFranchise(null);
  };

  const handleAddForm = () => {
    setIsEdit(false);
    setSelectedEditFranchise(null);
    setOpen(true);
  };

  const handleEditClick = (franchise = null) => {
    setIsEdit(true);
    setSelectedEditFranchise(franchise);
    setOpen(true);
  };

  const handleCloseForm = () => {
    setOpen(false);
  };

  const config = useMemo(() => {
    return getConfig();
  }, []);

  const fetchFranchise = (start_date = null, end_date = null) => {
    setLoading(true);
    axios
      .get(baseUrl + `superadmin/business/`, {
        params: {
          start_date: start_date || "",
          end_date: end_date || "",
        },
        ...config,
      })
      .then((response) => {
        setFranchiseData(response.data);
        setForFilterFranchisee(response.data);
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
      });
  };

  const fetchUserList = () => {
    setLoading(true);
    axios
      .get(baseUrl + `superadmin/business-users/`, config)
      .then((response) => {
        setUserList(response.data.results);
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchFranchise();
    fetchUserList();
  }, []);

  const handleSuspendClose = () => {
    setShowSuspendPopup(false);
  };

  const handleOpenSuspend = (franchId) => {
    setFranchiseeToSuspendId(franchId);
    setShowSuspendPopup(true);
  };
  const handleSuspend = (franchId) => {
    if (!franchiseeToSuspendId) return;

    setLoading(true);


    const franchise = franchiseData.find((f) => f.id === franchiseeToSuspendId);
    const isSuspended = franchise?.business_is_active ? "False" : "True";

    axios
      .post(
        `${baseUrl}superadmin/business/activate-deactivate/${franchiseeToSuspendId}/`,
        { is_active: isSuspended },
        {
          headers: {
            ...config.headers,
            "Content-Type": "application/json",
          },
        }
      )
      .then((response) => {
        setLoading(false);
        fetchFranchise();
        setSnackbar({
          open: true,
          message: response.data.message,
          severity: "success",
        });
        handleSuspendClose();
      })
      .catch((error) => {
        setLoading(false);
        console.error("Error suspending user:", error);
      });
  };

  const handleSnackbarClose = (event, reason) => {
    if (reason === "clickaway") return;
    setSnackbar({ ...snackbar, open: false });
  };


  const submitData = (newFranchise) => {
    setLoading(true);
    const formData = new FormData();

    formData.append("business_title", newFranchise.businessName);
    formData.append("place", newFranchise.place);
    formData.append("description", newFranchise.description);
    formData.append("mobile_number", newFranchise.mobileNumber);
    formData.append("user_name", newFranchise.userName);
    formData.append("user_phone", newFranchise.userPhone);
    formData.append("user_location", newFranchise.userLocation);
    formData.append("user_address", newFranchise.userAddress);
    axios
      .post(`${baseUrl}superadmin/business-create/`, formData, {
        headers: {
          ...config.headers,
          "Content-Type": "multipart/form-data",
        },
      })
      .then((response) => {
        setLoading(false);

        fetchFranchise();
        setSnackbar({
          open: true,
          message: response.data.message,
          severity: "success",
        });
      })
      .catch((error) => {
        setLoading(false);
        const errorMessage =
          error.response?.data?.message ||
          "An error occurred. Please try again.";
        setSnackbar({
          open: true,
          message: errorMessage,
          severity: "error",
        });
      });
  };

  const editData = (newFranchise) => {
    const id = selectedEditFranchise?.row.id;

    setLoading(true);
    const formData = new FormData();

    formData.append("business_title", newFranchise.businessName);
    formData.append("place", newFranchise.place);
    formData.append("description", newFranchise.description);
    formData.append("mobile_number", newFranchise.mobileNumber);

    axios
      .put(`${baseUrl}superadmin/business-update/${id}/`, formData, {
        headers: {
          ...config.headers,
          "Content-Type": "multipart/form-data",
        },
      })
      .then((response) => {
        setLoading(false);

        fetchFranchise();

        setSnackbar({
          open: true,
          message: response.data.message,
          severity: "success",
        });
      })
      .catch((error) => {
        setLoading(false);
        const errorMessage =
          error.response?.data?.message ||
          "An error occurred. Please try again.";
        setSnackbar({
          open: true,
          message: errorMessage,
          severity: "error",
        });
      });
  };


  return (
    <Container fluid className="franch-main">
      {loading ? (
        <div className="loader-container-franchise">
          <Spinner className="spinner-loader" />
        </div>
      ) : (
        <>
          {selectedFranchise ? (
            <FranchDetailPage
              franchise={selectedFranchise}
              onGoBack={handleGoBack}
            />
          ) : (
            <FranchTable
              franchise={forFilterFranchisee}
              onSelectFranchise={handleSelectFranchise}
              onEdit={handleEditClick}
              onDelete={handleSuspend}
              handleAddForm={handleAddForm}
              startDate={startDate}
              endDate={endDate}
              setStartDate={setStartDate}
              setEndDate={setEndDate}
              onReset={handleReset}
              onExport={exportToExcel}
              handleFilterFranchisee={handleFilterFranchisee}
              handleOpenSuspend={handleOpenSuspend}
            />
          )}
        </>
      )}
      <FranchForm
        open={open}
        onClose={handleCloseForm}
        onSubmit={isEdit ? editData : submitData}
        franchise={isEdit ? selectedEditFranchise?.row : null}
        userList={userList}
        isEdit={isEdit}
      />

      <Dialog
        open={showSuspendPopup}
        onClose={() => setShowSuspendPopup(false)}
        keepMounted
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle>Confirm Action</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            {franchiseData.find((u) => u.id === franchiseeToSuspendId)?.business_is_active
              ? "Do you want to deactivate this Franchisee?"
              : "Do you want to activate this Franchisee?"}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            size="small"
            color={
              franchiseData.find((u) => u.id === franchiseeToSuspendId)?.business_is_active
                ? "error"
                : "success"
            }
            style={{ textTransform: "none" }}
            onClick={handleSuspend}
          >
            {franchiseData.find((u) => u.id === franchiseeToSuspendId)?.business_is_active
              ? "Deactivate"
              : "Activate"}
          </Button>
          <Button
            size="small"
            style={{
              textTransform: "none",
              color: "grey",
              outline: "1px solid grey",
            }}
            onClick={handleSuspendClose}
          >
            cancel
          </Button>
        </DialogActions>
      </Dialog>

      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert onClose={handleSnackbarClose} severity={snackbar.severity}>
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Container>
  );
};

export default FranchMainScreen;




